import dynamic from 'next/dynamic'
import * as React from 'react'

import { BrandingOverrideProvider, BrandingOverrideValue, useBranding } from '@/hooks/use-branding'

import Footer from '@/components/layouts/footer'
import NavBar from '@/components/layouts/nav/navbar'

import {
  NON_FSDS_FOOTER_BRANDING_OVERRIDE,
  NON_FSDS_FOOTER_CONFIG,
  NON_FSDS_HEADER_BRANDING_OVERRIDE,
  NON_FSDS_HEADER_CONFIG,
} from '@/configs/non-fsds-config'

import type { FooterConfig, HeaderConfig } from '@/types/header-footer-config'

const GroupMessingButton = dynamic(() => import('@/components/shared/group-messing-button'), {
  ssr: false,
})

interface RootContainerProps {
  children?: React.ReactNode
  showMessingButton?: boolean
  showHeader?: boolean
  showFooter?: boolean
  headerConfig?: HeaderConfig
  footerConfig?: FooterConfig
  headerBrandingOverride?: BrandingOverrideValue
  footerBrandingOverride?: BrandingOverrideValue
  className?: string
  style?: React.CSSProperties
}

function RootContainer({
  children,
  showMessingButton = true,
  showHeader = true,
  showFooter = true,
  headerConfig: propHeaderConfig,
  footerConfig: propFooterConfig,
  headerBrandingOverride: propHeaderBrandingOverride,
  footerBrandingOverride: propFooterBrandingOverride,
  className,
  style,
}: RootContainerProps) {
  const { isFsdsDomain } = useBranding()
  const isNonFsds = !isFsdsDomain

  const headerConfig = propHeaderConfig ?? (isNonFsds ? NON_FSDS_HEADER_CONFIG : undefined)
  const footerConfig = propFooterConfig ?? (isNonFsds ? NON_FSDS_FOOTER_CONFIG : undefined)
  const headerBrandingOverride =
    propHeaderBrandingOverride ?? (isNonFsds ? NON_FSDS_HEADER_BRANDING_OVERRIDE : undefined)
  const footerBrandingOverride =
    propFooterBrandingOverride ?? (isNonFsds ? NON_FSDS_FOOTER_BRANDING_OVERRIDE : undefined)

  const containerClassName = `flex min-h-screen flex-col ${isFsdsDomain ? '' : 'theme-non-fsds'} ${className || ''}`

  return (
    <>
      <div className={containerClassName} style={style}>
        {showHeader && (
          <BrandingOverrideProvider value={headerBrandingOverride ?? {}}>
            <NavBar headerConfig={headerConfig} />
          </BrandingOverrideProvider>
        )}
        <main className="flex-grow">{children}</main>
        {showFooter && (
          <BrandingOverrideProvider value={footerBrandingOverride ?? {}}>
            <Footer footerConfig={footerConfig} />
          </BrandingOverrideProvider>
        )}
      </div>
      {showMessingButton && isFsdsDomain && <GroupMessingButton />}
    </>
  )
}

export default RootContainer
